import { useAuth } from "@auth/AuthContext"
import { analytics } from "@lib/analytics"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { classroomRosterId, isProfessorRoute, toRoutePattern } from "@/constants/analytics"

/**
 * Tracks only authenticated professor routes. Public student/token routes
 * stay outside the analytics surface even when a stale session is present.
 *
 * Sends the route PATTERN (`/salones/:id/alumnos`), never the raw pathname —
 * see `toRoutePattern` for why.
 */
export function ProfessorAnalytics() {
  const { professor } = useAuth()
  const { pathname } = useLocation()
  const professorId = professor?.id

  useEffect(() => {
    if (!professorId || !isProfessorRoute(pathname)) return

    analytics.track("page_viewed", { route: toRoutePattern(pathname) })

    // Earns its place next to `page_viewed` by carrying the classroom id,
    // which the de-identified route pattern deliberately drops. A professor's
    // own classroom id is not student data and makes "which classrooms does
    // this professor actually work in" answerable.
    const classroomId = classroomRosterId(pathname)
    if (classroomId) {
      analytics.track("classroom_roster_opened", { classroom_id: classroomId })
    }
  }, [pathname, professorId])

  return null
}
